export default __webpack_public_path__ + "static/media/dublin_zoo_logo.f5b97ca0.png";